"use client";
import React from "react";
import {useTranslations} from 'next-intl'
import {cn} from "@/lib/utils";
import Image from "next/image";

interface FeatureProps {
    config?: any;
}

export function Feature({config}: FeatureProps) {
    const t = useTranslations('home.feature')
    return (
        <div className="bg-blue-50 py-8">
            <div className="container flex flex-col gap-12 py-12 px-0 h-full text-foreground dark:text-background/90">
                <h6 className="text-base md:text-xl items-center text-center justify-center text-blue-600 font-medium flex w-full h-full  ">
                    像人一样说话的 AI
                </h6>
                <h2 className="text-3xl md:text-3xl font-medium  text-center w-full h-full ">
                    数据
                </h2>
                <h2 className="text-base md:text-xl text-center w-full h-full">
                    通过应用最先进的语音与大模型技术，我们提供逼近真人的 AI 沟通体验
                </h2>

                <div className="items-start gap-8 md:justify-center w-full h-full md:grid lg:grid-cols-4 xl:grid-cols-4">
                    <div className="p-4  bg-white dark:bg-card/20 rounded-md md:flex-col items-start space-y-4 border flex flex-col h-full">
                        <h6 className="text-base md:text-md text-blue-600 font-medium flex w-full ">
                            活跃客户
                        </h6>
                        <h1 className="text-3xl items-start flex font-bold  w-full ">
                            109
                        </h1>
                        <h2 className="text-sm items-center justify-center flex w-full  ">
                            我们在全国 20+ 城市都有合作客户，几乎遍布呼叫中心涉及的所有业务。
                        </h2>
                        <h6 className="text-sm text-center justify-center bg-blue-50 py-2 rounded flex w-full ">
                            点击 “播放” 按钮听效果
                        </h6>
                    </div>
                    <div className="p-4  bg-white dark:bg-card/20 rounded-md md:flex-col items-start space-y-4 border flex flex-col h-full">
                        <h6 className="text-base md:text-md text-blue-600 font-medium flex w-full ">
                            日均触达用户数
                        </h6>
                        <h1 className="text-3xl items-start flex font-bold   w-full ">
                            1,000,000+
                        </h1>
                        <h2 className="text-sm items-center justify-center flex w-full ">
                            过去半年增长了 10 倍，直至今日，触达用户依然保持每个月 20%+ 的增长速度，
                        </h2>
                        <h6 className="text-sm text-center justify-center bg-blue-50 p-2 rounded flex w-full ">
                            这叫什么地方？浙江什么地方？这叫这叫什么大洋啊？
                        </h6>
                    </div>
                    <div className="p-4 bg-white dark:bg-card/20 rounded-md md:flex-col items-start space-y-4 border flex flex-col h-full">
                        <h6 className="text-base md:text-md text-blue-600 font-medium flex w-full ">
                            营销成交
                        </h6>
                        <h1 className="text-3xl items-start flex font-bold   w-full">
                            5,000+
                        </h1>
                        <h2 className="text-sm items-center justify-center flex w-full ">
                            不仅实现电话营销，还涵盖智能派单与质检，覆盖营销全流程，每日都在达成成交。
                        </h2>
                        <h6 className="text-sm mb-0 text-center justify-center bg-blue-50 p-2 rounded flex w-full ">
                            点击 “播放” 按钮听效果
                        </h6>
                    </div>
                    <div className="p-4  bg-white dark:bg-card/20 rounded-md md:flex-col items-start space-y-4 border flex flex-col h-full">
                        <h6 className="text-base md:text-md text-blue-600 font-medium flex w-full ">
                            服务满意
                        </h6>
                        <h1 className="text-3xl items-start flex font-bold   w-full">
                            86%
                        </h1>
                        <h2 className="text-sm items-center justify-center flex w-full ">
                            呼叫中心的使命就是让用户满意，我们通过回访，NPS打分等手段收集用户反馈，全面提升服务质量。
                        </h2>
                        <h6 className="text-sm text-center justify-center bg-blue-50 p-2 rounded flex w-full ">
                            这叫什么地方？浙江什么地方？
                        </h6>
                    </div>
                </div>
            </div>
        </div>
    );
}